var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseModalImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.50515,
    y: 1.3572,
    width: 41.9228,
    height: 41.9228,
    rx: 20.9614,
    stroke: "#EBEFF2",
    strokeWidth: 1.19779
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4973 17.2959C27.4234 17.2218 27.3357 17.1631 27.2391 17.123C27.1425 17.083 27.0389 17.0623 26.9343 17.0623C26.8298 17.0623 26.7262 17.083 26.6296 17.123C26.533 17.1631 26.4452 17.2218 26.3714 17.2959L22.4666 21.1927L18.5618 17.2879C18.4878 17.2139 18.4001 17.1553 18.3035 17.1153C18.2069 17.0753 18.1033 17.0547 17.9988 17.0547C17.8942 17.0547 17.7907 17.0753 17.6941 17.1153C17.5975 17.1553 17.5098 17.2139 17.4358 17.2879C17.3619 17.3618 17.3033 17.4496 17.2632 17.5462C17.2232 17.6428 17.2026 17.7463 17.2026 17.8508C17.2026 17.9554 17.2232 18.0589 17.2632 18.1555C17.3033 18.2521 17.3619 18.3399 17.4358 18.4138L21.3406 22.3186L17.4358 26.2234C17.3619 26.2974 17.3033 26.3851 17.2632 26.4817C17.2232 26.5783 17.2026 26.6818 17.2026 26.7864C17.2026 26.8909 17.2232 26.9945 17.2632 27.0911C17.3033 27.1877 17.3619 27.2754 17.4358 27.3493C17.5098 27.4233 17.5975 27.4819 17.6941 27.5219C17.7907 27.5619 17.8942 27.5825 17.9988 27.5825C18.1033 27.5825 18.2069 27.5619 18.3035 27.5219C18.4001 27.4819 18.4878 27.4233 18.5618 27.3493L22.4666 23.4445L26.3714 27.3493C26.4453 27.4233 26.5331 27.4819 26.6297 27.5219C26.7263 27.5619 26.8298 27.5825 26.9343 27.5825C27.0389 27.5825 27.1424 27.5619 27.239 27.5219C27.3356 27.4819 27.4234 27.4233 27.4973 27.3493C27.5712 27.2754 27.6299 27.1877 27.6699 27.0911C27.7099 26.9945 27.7305 26.8909 27.7305 26.7864C27.7305 26.6818 27.7099 26.5783 27.6699 26.4817C27.6299 26.3851 27.5712 26.2974 27.4973 26.2234L23.5925 22.3186L27.4973 18.4138C27.8007 18.1104 27.8007 17.5993 27.4973 17.2959Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalImg);
export default __webpack_public_path__ + "static/media/closeModalImg.2c9a28e89fa53014b5f15d0296ca156c.svg";
export { ForwardRef as ReactComponent };